import React from 'react';
import {
  Flex,
  Grid,
  GridItem,
  Text,
  useDisclosure,
  Alert,
  AlertIcon,
  Box,
  Link,
  chakra,
} from '@chakra-ui/react';
import {AgentType} from '../../../shared/agent';
import {AgentBuilderModal} from './AgentBuilderModal';
import {AgentBuilderCard, AgentBuilderTypeCard} from './AgentBuilderTypeCard';
import {useAgentLimits} from '../../Agents/useAgentLimits';
import {ChartPie} from '@carbon/icons-react';
import {AgentTypeInfo} from './agentTypeInfo';
import {AgentWizard, AgentWizardModal} from './wizard/AgentWizardModal';
import {getAgentCreditEstimateCost} from '../../../shared/credits';

export const AgentQuickStartMenu = () => {
  const agentBuilderModal = useDisclosure();
  const agentWizardModal = useDisclosure();
  const [agentType, setAgentType] = React.useState<AgentType>();
  const [wizardType, setWizardType] = React.useState<AgentWizard>();
  const {limitExceeded, limitMessage} = useAgentLimits();

  // Set up the agent builder store when a card is clicked
  const handleCardClick = (agentType: AgentType) => {
    // Set the agent type in the store
    setAgentType(agentType);
    // Open the modal
    agentBuilderModal.onOpen();
  };

  const handleWizardClick = (wizardType: AgentWizard) => {
    setWizardType(wizardType);
    agentWizardModal.onOpen();
  };

  return (
    <Flex direction="column" gap="4" p="4" my="4">
      <Text textColor="kgray.400">Quick start by picking an agent</Text>
      {limitExceeded && (
        <Alert status="warning" borderRadius="md">
          <AlertIcon />
          <Box>
            {limitMessage}{' '}
            <Link color="kblue.400" href="mailto:support@keyplay.io" isExternal>
              Contact Keyplay support to increase your limit
            </Link>
          </Box>
        </Alert>
      )}
      <Grid
        templateColumns={{
          base: '1fr',
          md: 'repeat(2, 1fr)',
          lg: 'repeat(3, 1fr)',
          xl: 'repeat(4, 1fr)',
          '2xl': 'repeat(5, 1fr)',
        }}
        gap="4"
      >
        <GridItem key="legacyTeamSize">
          <AgentBuilderTypeCard
            agentType="legacyTeamSize"
            onClick={() => handleCardClick('legacyTeamSize')}
            isDisabled={limitExceeded}
          />
        </GridItem>
        <GridItem key="analystWizard">
          <AgentBuilderCard
            onClick={() => handleWizardClick('analyst')}
            isDisabled={limitExceeded}
            description={AgentTypeInfo.researchAndAnalyst.description}
            label="Researcher & Analyst"
            creditCost={'1-4'}
            AgentIcon={AgentTypeInfo.researchAndAnalyst.icon}
          />
        </GridItem>
        <GridItem key="segmentationWizard">
          <AgentBuilderCard
            onClick={() => handleWizardClick('segmentation')}
            isDisabled={limitExceeded}
            description={AgentTypeInfo.analyst.description}
            label="Segmentation Analyst"
            creditCost={getAgentCreditEstimateCost('analyst')}
            AgentIcon={chakra(ChartPie)}
          />
        </GridItem>
      </Grid>
      <AgentBuilderModal
        isOpen={agentBuilderModal.isOpen}
        onClose={agentBuilderModal.onClose}
        initialStep="setName"
        initialType={agentType}
      />
      {wizardType && (
        <AgentWizardModal
          isOpen={agentWizardModal.isOpen}
          onClose={agentWizardModal.onClose}
          wizardType={wizardType}
        />
      )}
    </Flex>
  );
};
